<template>

  <template v-if="props.values.length == 0">
    <Card class="mb-0 mt-0">
      <template #content>
        {{ $t("noRecordsFound") }}
      </template>
    </Card>
  </template>

  <Card v-for="data, key in props.values" :key="key" class="mb-0 mt-0">
    <template #content>
      <table class="table-fixed w-full">
        <tbody>
          <tr v-for="col in props.columns" :key="col.field" class="m-3">
            <th class="text-start">{{ $t(col.header) }}</th>
            <td class="text-end">
              <component v-bind="col.dynamic && col.innerPropsGenerator && data
                ? col.innerPropsGenerator(data)
                : col.innerProps
                " :is="col.inner ?? 'span'">
                {{
                  col.dynamic && col.innerDataGenerator && data
                    ? col.innerDataGenerator(data)
                    : callRule(col.field, data)
                }}
              </component>
            </td>
          </tr>
        </tbody>
      </table>
    </template>
  </Card>
</template>

<script lang="ts" setup>
import { get } from "lodash"
import Card from "primevue/card"
import type { TableColumn } from './alerts/types'
import { computed } from "vue"

const callRule = (field: string, data: Record<string, unknown>) => {
  if (!formattingRules.value || !data || !field) {
    return
  }
  const fieldValue = get(data, field) as string
  const rules = formattingRules.value
  if (field in rules) {
    return rules[field]?.(fieldValue, data, field)
  }
  return fieldValue
}

const formattingRules = computed(() => {
  return props.formattingRules ?? {}
})

const props = defineProps<{
  columns: TableColumn[]
  values: any[]  // eslint-disable-line
  formattingRules?: Record<
    string,
    (v: any, ctx?: Record<string, any>, field_name?: string) => any // eslint-disable-line
  >
}>()
</script>
